// extracted by mini-css-extract-plugin
module.exports = {"Language":"Language_Language__1d0x8","LanguageActive":"Language_LanguageActive__1LkfC"};